import { render, staticRenderFns } from "./additional-material-modal.vue?vue&type=template&id=ff8f5f36&scoped=true&"
import script from "./additional-material-modal.vue?vue&type=script&lang=js&"
export * from "./additional-material-modal.vue?vue&type=script&lang=js&"
import style0 from "./additional-material-modal.vue?vue&type=style&index=0&id=ff8f5f36&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff8f5f36",
  null
  
)

export default component.exports